export default __webpack_public_path__ + "static/media/With_mascot.f1d71aed.gif";